import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "various-sharingmail",
  "use": "various-sharingmail-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol viewBox=\"0 0 40 40\" xmlns=\"http://www.w3.org/2000/svg\" id=\"various-sharingmail\"><path d=\"M20 39.998C8.953 39.998 0 31.044 0 20 0 8.954 8.954 0 20 0c11.044 0 19.998 8.954 19.998 20 0 11.044-8.954 19.998-19.999 19.998zM9 13l11 8 11-8H9zm0 2v12h22V15l-11 8-11-8z\" fill=\"#e3000f\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol